import * as React from 'react';
import { htmlDecode } from '../helpers/functions';
import { FormFields } from './Fields';
import { Form } from 'react-final-form';
import axios from 'axios';

import { sendForm, apiCall } from '../helpers/apiCall';

import { ReactComponent as Loading } from '../assets/loading.svg';

export function FormDisplay({ fields }) {
  let initialValues = {};

  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);

  const submitForm = async (values) => {
    let response;
    let formData = new FormData();

    setLoading(true);

    formData.append('action', 'api_gravity_forms');
    formData.append('form_id', fields.formId);

    Object.keys(values).map((val) => {
      formData.append(val, values[val]);
    });
    try {
      response = await axios.post('/wp-admin/admin-ajax.php', formData);
      console.log(response);
    } catch (error) {}
    if (response.data.is_valid) {
      window.location.href = response.data.confirmation_redirect;
    } else {
      setLoading(false);
      setErrorMessage('Form was unable to submit');
    }
  };
  return (
    <section className="container relative text-content">
      {fields && (
        <Form
          onSubmit={submitForm}
          initialValues={initialValues}
          mutators={{
            setValue: ([field, value], state, { changeValue }) => {
              changeValue(state, field, () => value);
            },
          }}
          validate={(values) => {
            const errors = {};

            fields.fields.forEach((field) => {
              const key = 'input_' + field.id;
              if (field.required && !values.hasOwnProperty(key)) {
                errors.validate = true;
              }
            });

            return errors;
          }}
          render={({
            handleSubmit,
            form,
            submitting,
            pristine,
            values,
            errors,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <FormFields fields={fields.fields} form={form} />
                <div className="px-2">
                  <button
                    type="submit"
                    className="inline-block px-12 py-3 bg-primary hover:bg-secondary transition duration-250 text-white uppercase font-bold"
                    disabled={errors.validate || loading ? true : false}
                  >
                    {loading ? (
                      <Loading className="h-4" />
                    ) : (
                      <span>
                        {fields.submitText ? fields.submitText : 'Submit'}
                      </span>
                    )}
                  </button>
                </div>
                {errorMessage && (
                  <div className="text-center font-bold py-4">
                    {errorMessage}
                  </div>
                )}
              </form>
            );
          }}
        />
      )}
    </section>
  );
}
